export const environment = {
  production: false,
  envName: 'devserver',
  SERVICE_URL: 'https://apitest.bcbsal.org',
  API_KEY: '444-0d1b828f-d275-4968-8d1c-c3515cee626c',
  EnsightenEnv: 'bcbsal_dev'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts